import { memo, useCallback } from 'react';
import { Stack } from '@mui/material';
import { DeleteRowAction, EditRowActions } from '@dfl/mui-admin-layout';
import { useToggle } from '@dfl/hook-utils';
import { useDeleteIncidence } from '../../hooks/useDeleteIncidence';
import { IIncidence } from '../../interfaces';
import { useNavigate } from 'react-router';

type UserStatusProps = {
  rowId: string;
  incidence: IIncidence;
};

const IncidenceRowActions = ({ rowId, incidence }: UserStatusProps) => {
  const { isOpen, onClose, onOpen } = useToggle();
  const navigate = useNavigate();
  const { mutate, isPending, error } = useDeleteIncidence(rowId, onClose);

  const handleEdit = useCallback(() => {
    navigate(`/sales/incidences/${rowId}/general?edit=true`);
  }, [navigate, rowId]);

  return (
    <>
      <Stack direction='row' spacing={1}>
        <EditRowActions onClick={handleEdit} />
        <DeleteRowAction
          disabled={incidence?.actions && incidence?.actions?.length > 0}
          isOpen={isOpen}
          onOpen={onOpen}
          onClose={onClose}
          error={error}
          isLoading={isPending}
          onDelete={mutate}
        />
      </Stack>
    </>
  );
};

export default memo(IncidenceRowActions);
